import { DisplayColumns } from "types"

export const parseDisplayNumericColumns = (columns: DisplayColumns): number =>
    ({
        [DisplayColumns.One]: 1,
        [DisplayColumns.Two]: 2,
        [DisplayColumns.Three]: 3,
        [DisplayColumns.Four]: 4
    })[columns] || 2
